import React from 'react';
import { Tree } from 'antd';
import { isArray } from 'src/utils/typeGuards';
import TreeProps from '../../types/TreeProps';
import TreeNodeProps from '../../types/TreeNodeProps';
import styles from './LookupOptions.module.less';

const { TreeNode } = Tree;

type CustomFiltersProps = {
  data: TreeNodeProps[];
  currentValue: string[];
  onChange: (val: string[]) => void;
};

const renderTreeNodes = (data: TreeNodeProps[]) =>
  data.map((item: TreeNodeProps) => {
    const { children, ...props } = item;
    return (
      <TreeNode {...props} key={props.id}>
        {children && renderTreeNodes(children)}
      </TreeNode>
    );
  });

export const CustomFilters: React.FC<CustomFiltersProps> = ({ data, currentValue, onChange }) => {
  const handleChange = (val: TreeProps.CheckedKeys) => {
    if (isArray(val)) {
      onChange(val);
    }
  };

  return (
    <div className={styles.selectTreeWrapper}>
      {data.length > 0 && (
        <Tree selectable={false} checkable={true} showLine={true} onCheck={handleChange} checkedKeys={currentValue}>
          {renderTreeNodes(data)}
        </Tree>
      )}
    </div>
  );
};
